import { MarketType } from "../types";

const JAPAN_HOSTS = ["dip-stg.world-family.co.jp", "dip.world-family.co.jp"];

export default function getMarket(
  search = window.location.search,
  hostname = window.location.hostname,
): MarketType | null {
  if (JAPAN_HOSTS.includes(hostname.toLowerCase())) return "JP";

  const market = new URLSearchParams(search).get("market");

  return (market as MarketType) || null;
}
